@if (data) {
  <div class="container-fluid">
    <div class="row">
      <div class="col-md">
        <span>
          <label>{{ "TOOLTIP.CREDITS.AUTHOR" | translate }}</label>
          <label [innerHTML]="data.author || '-'"></label>
        </span>

        <span>
          <label>{{ "TOOLTIP.CREDITS.CREATION" | translate }}</label>
          <label [innerHTML]="data.createdAt || '-'"></label>
        </span>

        <span>
          <label>{{ "TOOLTIP.CREDITS.EDITED" | translate }}</label>
          <label [innerHTML]="data.editedAt || '-'"></label>
        </span>

        <span>
          <label>{{ "TOOLTIP.CREDITS.EDITOR" | translate }}</label>
          <label [innerHTML]="data.editor || '-'"></label>
        </span>
      </div>
    </div>
  </div>
}
